import React, { Component } from 'react';
import { FooterBtn, StickyNote } from '../../common';
import './Footer.scss';

export default class Footer extends Component {
  render() {
    const {
      issueInfo,
      submitBtnTitle,
      stickyTitle,
      btnBgColor,
      sendFormData,
      isDisabled,
      info = null,
    } = this.props;
    if (issueInfo && !issueInfo?.toast && !issueInfo?.submit_button)
      return null;
    return (
      <div className='footer'>
        {((issueInfo && issueInfo?.toast) || stickyTitle) && (
          <StickyNote
            title={stickyTitle || issueInfo?.toast.text}
            bgColor={issueInfo?.toast.bg_color}
            color={issueInfo?.toast.color}
            type={issueInfo?.toast.type}
          />
        )}
        {((issueInfo && issueInfo?.submit_button) || submitBtnTitle) && (
          <FooterBtn
            title={submitBtnTitle || issueInfo?.submit_button.text}
            bgColor={btnBgColor || issueInfo?.submit_button.bg_color}
            onClick={sendFormData}
            isDisabled={isDisabled}
            info={info}
          />
        )}
      </div>
    );
  }
}
